<template>
    <CRow>
        <CCol col>
            <ejs-grid ref='gridtp' :dataSource="tradeData" :allowFiltering='true' :allowPaging="true" :allowResizing='true' :enablePersistence ="true" :toolbarClick='toolbarClick' :allowExcelExport='true' :excelExportComplete='excelExportComplete' :allowReordering='true' :allowSorting='true' :editSettings='editSettings' :toolbar='toolbar' :pageSettings='pageSettings' :actionComplete='actionComplete' :actionFailure="actionFailure" :actionBegin="actionBegin" :filterSettings='filterOptions'>
                <e-columns>
                    <e-column field='tradePeriodId' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>
                    <e-column field='name' headerText='Name' :validationRules="nameRules" width=120></e-column>
                    <e-column field='code' headerText='Code' :validationRules="codeRules" textAlign='Right'  width=90></e-column>
                    <e-column field='indicator' headerText='Indicator' textAlign='Right' :allowEditing="false"  :validationRules="indicatorRules"  width=90></e-column>
                    <e-column field='shaped' headerText='Shaped' textAlign='Right' displayAsCheckBox='true' :allowEditing="false"   editType= 'booleanedit' width=90></e-column>
                </e-columns>
            </ejs-grid>
        </CCol>
    </CRow>
</template>
<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import SyncHelper from '../../../common/syncfusion';
    import gridOptions from '../../../common/gridOptions'
    import store from '../../../store';
    Vue.use(UploaderPlugin);
    Vue.use(DialogUtility);
    Vue.use(GridPlugin);

    export default {
        components: {
        },
        data() {
            return {
                store: store,

                tradeData: SyncHelper.getDataManager("TradePeriods"),

                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowAdding: false,
                    allowDeleting: false,
                    mode: 'Dialog'
                },
                toolbar: ['Add', 'Delete', 'ExcelExport'],
                requiredRules: { required: true },
                nameRules: { required: true, maxLength: 50 },
                codeRules: { required: true, maxLength: 12 },
                indicatorRules: { required: true, maxLength: 2 },
                filterOptions: gridOptions.filterSettings
            };
        },
        methods: {
            toolbarClick(args) {
                gridOptions.excelExport(args, "Trade Periods.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.gridtp.hideSpinner();
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
            }
        },

        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    };

</script>
<style>
</style>
